import React from "react"
import ProductListTableComponent from "./productStockListTable.component"

export default function ProductStockListTableContainer({
  rows,
  isFetching,
  isError,
  handleReload,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  isSearchResult,
  totalFiltered,
  viewActivityLog,
  tableFilter,
  changeSequenceOrder,
  lang,
  paginationOptions,
  handleViewDetail
}) {
  return (
    <ProductListTableComponent 
      rows={rows}
      isFetching={isFetching}
      isError={isError}
      handleReload={handleReload}
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangePage={handleChangePage}
      handleChangeRowPerPage={handleChangeRowsPerPage}
      isSearchResult={isSearchResult}
      totalFiltered={totalFiltered}
      viewActivityLog={viewActivityLog}
      tableFilter={tableFilter}
      changeSequenceOrder={changeSequenceOrder}
      lang={lang}
      paginationOptions={paginationOptions}
      handleViewDetail={handleViewDetail}
    />
  )
}